import type { AxiosResponse } from 'axios';
import type { Schema } from 'src/generated/api-helpers';
import type { OnErrorHandler } from 'src/helpers/api';
import { request } from 'src/helpers/api';
import type { PatchedPropertyManagerProfileResource } from 'src/types/auth';

type ApiResponse<T = any> = Promise<AxiosResponse<T>>;

type AuthenticateRequest = Schema<'AuthenticateRequest'>;

// TODO: improve openapi types from core-be
export type LoginParams =
	| {
			email: string;
			password: NonNullable<AuthenticateRequest['password']>;
			remember?: 1 | undefined;
	  }
	| Required<Pick<AuthenticateRequest, 'pm_auth_token'>>;

type ForgotPasswordParams = Schema<'ForgotPasswordRequest'>;

interface ResetPasswordParams {
	token: string;
	password: string;
	password_confirmation: string;
}

interface ForceResetPasswordParams {
	current_password: string;
	password: string;
	password_confirmation: string;
}

interface PusherAuthParams {
	socket_id: string;
	channel_name: string;
}

export const login = (params: LoginParams): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/login',
		params,
		is_authenticated: false,
	});

export const forgotPassword = (params: ForgotPasswordParams): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/password/forgot',
		params,
	});

export const logout = ({
	onError,
}: {
	onError?: OnErrorHandler;
} = {}): ApiResponse =>
	request({
		method: 'DELETE',
		url: '/api/logout',
		onError,
	});

export const resetPassword = (params: ResetPasswordParams): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/password/reset',
		params,
	});

export const defaultCustomerResetPassword = (
	params: ForceResetPasswordParams,
): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/password/force-reset',
		params,
	});

export const fetchLoggedInUserDetails = ({
	onError,
}: {
	onError?: OnErrorHandler;
} = {}): ApiResponse<PatchedPropertyManagerProfileResource> =>
	request({
		method: 'GET',
		url: '/api/customer/v1/profile',
		onError,
	});

export const requestExtensionCode = (): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/auth/extension/authorize',
		cancel_token: 'extension-authorize',
	});

export const authPusher = (params: PusherAuthParams): ApiResponse =>
	request({
		method: 'POST',
		url: '/broadcasting/auth',
		params,
	});

export const sendMagicLink = (params: ForgotPasswordParams): ApiResponse =>
	request({
		method: 'POST',
		url: '/api/auth/send-magic-link',
		params,
	});
